import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@afosto/components-react/AppBar';
import AppBarRow from '@afosto/components-react/AppBarRow';
import AppBarIconButton from '@afosto/components-react/AppBarIconButton';
import AppBarSearch from '@afosto/components-react/AppBarSearch';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useAppActions } from '../AppProvider';
import Icon from '../Icon';

const SearchBar = ({ position, renderMenuIcon, searchInputProps, value, onSearch }) => {
  const intl = useIntl();
  const [actions] = useAppActions();
  const [searchValue, setSearchValue] = useState(value);

  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  /**
   * Handle changing the search value.
   * @param {Event} event
   */
  const handleChange = event => {
    const { target } = event;

    if (searchInputProps.onChange) {
      searchInputProps.onChange(event);
    }

    setSearchValue(target.value || '');
  };

  /**
   * Handle enter key in search field.
   * @param {Event} event
   */
  const handleSearch = event => {
    const { key } = event || {};

    if (searchInputProps.onKeyDown) {
      searchInputProps.onKeyDown(event);
    }

    if (key && key.toLowerCase() === 'enter' && onSearch) {
      onSearch(searchValue);
    }
  };

  return (
    <AppBar position={position}>
      <AppBarRow>
        {renderMenuIcon && (
          <AppBarIconButton onClick={() => actions.toggleIsDrawerOpen()}>
            <Icon icon={['fal', 'bars']} size="small" />
          </AppBarIconButton>
        )}
        <AppBarSearch
          {...searchInputProps}
          value={searchValue}
          onChange={handleChange}
          onKeyDown={handleSearch}
          placeholder={
            searchInputProps.placeholder ||
            intl.formatMessage({
              id: 'app.searchBar.search.placeholder',
              defaultMessage: 'Search',
              description: 'placeholder of the search input',
            })
          }
          inputProps={{
            'aria-label': intl.formatMessage({
              id: 'app.searchBar.search.label',
              defaultMessage: 'Search',
              description: 'label of the search input',
            }),
          }}
        />
      </AppBarRow>
    </AppBar>
  );
};

SearchBar.propTypes = {
  position: PropTypes.string,
  renderMenuIcon: PropTypes.bool,
  searchInputProps: PropTypes.object,
  value: PropTypes.string,
  onSearch: PropTypes.func,
};

SearchBar.defaultProps = {
  position: undefined,
  renderMenuIcon: false,
  searchInputProps: {},
  value: '',
  onSearch: undefined,
};

export default SearchBar;
